module.exports = __webpack_public_path__ + "img/JT_icons01_64px_SeenOff.3c8a59b1.svg";